import type { TUser } from './user';
import type { TLabel } from './label';
import type { TOrganization } from './organization';
import type { TProgram } from './program';
import type { ValueOf } from './utilities';
import type { TStudent } from './student';
import type { TPartner } from '@src/features/users/services/partners-api';

export const SUBMISSION_STATUS = {
  pendingApproval: 'PENDING_APPROVAL',
  inProgress: 'IN_PROGRESS',
  submitted: 'SUBMITTED',
  submittedToPartner: 'SUBMITTED_TO_PARTNER',
  returned: 'RETURNED',
  approved: 'APPROVED',
  withdrawn: 'WITHDRAWN',
  archived: 'ARCHIVED',
};

export const SUBMISSION_PRIORITY = {
  Low: 'LOW',
  medium: 'MEDIUM',
  heigh: 'HIGH',
} as const;

export type TSubmission = {
  id: number;
  submitted_by: TUser;
  formatted_sharable_uid: number;
  assignee: TUser;
  partner: TPartner | null | undefined;
  program: TProgram;
  labels: TLabel[];
  organization: TOrganization;
  visa_status: 'COMPLETED' | 'INCOMPLETE' | 'IN_PROGRESS';
  priority: ValueOf<typeof SUBMISSION_PRIORITY>;
  status?: ValueOf<typeof SUBMISSION_STATUS>;

  no_of_questions: number;
  no_of_questions_answered: number;

  no_of_required_questions: number;
  no_of_answered_required_fields: number;

  no_of_documents: number;
  no_of_documents_answered: number;

  created_at: string;
  updated_at: string;
  visa_completion_date: string;

  student: TStudent;
};
